import { defaultApiInt, newApiFetch } from "./utils";

export const getKpiUpdateData = (): defaultApiInt => newApiFetch("/admin/kpi_update/get/", {});
